import React, { useState } from 'react'
import logo from "../../images/logo.png"
import { Link  } from "react-router-dom"

let user;

const sendUser = ()=>{
  user =  document.getElementById('joinInput').value
  document.getElementById('joinInput').value = ""
 }

const Join = () => {

  const [name ,setName]  = useState('');

  const handlebar = (e)=>{
    setName(e.target.value)
  }

  const sendbar = (event)=>{
     return (!name ? event.preventDefault():null)
     }

  
    return (
      <>
        <div className = "JoinPage">
          <div className = "JoinContainer">
            <img src = {logo} alt = "logo" />
            <h1> CHAT-APP</h1>
            <input type = "text" placeholder = "Enter Your Name" id = "joinInput" onChange = {handlebar}/>
            <Link onClick = {sendbar} to = "/chat"><button onClick = {sendUser} className  = "btn"> Login ln</button></Link>

          </div>
           
        </div>
        </> 
    )
   
}



export default Join

export {user}